import React, { useEffect, useState } from 'react';
import { useData } from '../../data/DataProvider';
import { useToast } from '../../shared/components/ToastProvider';
import { portalApi } from '../../lib/api';

// Stripe Connect onboarding (pass 6 §6E). The tenant's stripe_account_id
// is created on first "Connect" click; connect-status polls the live
// account state (charges_enabled etc.) after returning from onboarding.
export default function PaymentsSettings() {
  const { data, refresh } = useData();
  const { notify } = useToast();
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const loadStatus = async () => {
    try {
      const result = await portalApi.stripeConnectStatus();
      setStatus(result);
    } catch {
      setStatus({ configured: false, account_id: '', account: null });
    }
  };

  useEffect(() => {
    loadStatus();
  }, []);

  const connect = async () => {
    setBusy(true);
    try {
      const result = await portalApi.stripeConnectLink();
      await refresh();
      notify('Stripe onboarding opened — complete the steps, then come back here.');
      window.location = result.url;
    } catch (err) {
      notify(err.message || 'Could not start Stripe onboarding', 'error');
    } finally {
      setBusy(false);
    }
  };

  const recheck = async () => {
    setBusy(true);
    try {
      await refresh();
      await loadStatus();
      notify('Payment status refreshed');
    } catch (err) {
      notify(err.message || 'Refresh failed', 'error');
    } finally {
      setBusy(false);
    }
  };

  const accountId = data.tenant.stripe_account_id || status?.account_id || '';
  const account = status?.account;

  return (
    <section className="panel settings-form">
      <h3>Payments</h3>
      <p className="field-hint">Take card payments through your own Stripe account. Each invoice shows a “Pay now” button in the client portal once this is set up.</p>

      {!status?.configured && (
        <p className="field-hint">Stripe isn&apos;t configured on the server (STRIPE_SECRET_KEY missing) — card payments are disabled platform-wide.</p>
      )}

      <dl className="detail-list">
        <dt>Stripe account</dt>
        <dd>{accountId || 'Not connected'}</dd>
        {account && <><dt>Charges</dt><dd>{account.charges_enabled ? <span className="status-pill status-paid"><span className="status-dot" />Enabled</span> : <span className="status-pill status-pending"><span className="status-dot" />Pending onboarding</span>}</dd></>}
        {account && <><dt>Payouts</dt><dd>{account.payouts_enabled ? 'Enabled' : 'Pending'}</dd></>}
      </dl>

      <div className="header-actions">
        {!accountId && status?.configured && (
          <button className="primary-button" onClick={connect} disabled={busy}>{busy ? 'Opening Stripe…' : 'Connect your bank account via Stripe'}</button>
        )}
        {accountId && (
          <>
            <button className="secondary-button" onClick={connect} disabled={busy}>{busy ? 'Opening Stripe…' : 'Continue onboarding'}</button>
            <button className="secondary-button" onClick={recheck} disabled={busy}>{busy ? 'Checking…' : 'Refresh status'}</button>
          </>
        )}
      </div>
    </section>
  );
}
